// src/pages/ChangePasswordPage.js

import React, { useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Logo from '../components/Logo';

function ChangePasswordPage({ csrfToken }) {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')

  async function handleChange(e) {
    e.preventDefault()
    setError('')
    setMessage('')

    try {
      await axios.post('/change-password', {
        oldPassword,
        newPassword
      }, {
        headers: { 'X-CSRF-Token': csrfToken },
        withCredentials: true
      })

      setMessage(t('changePassword.success'))
      setOldPassword('')
      setNewPassword('')
      // Optional: navigate('/hr/overview')
    } catch (err) {
      setError(
        err.response?.data && typeof err.response.data === 'string'
          ? err.response.data
          : t('changePassword.error')
      )
    }
  }

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-6 text-white">
      <div className="mb-10">
        <Logo variant="wordmark" size="xxxl" />
      </div>

      <h2 className="text-3xl md:text-4xl font-bold mb-8">
        {t('changePassword.heading')}
      </h2>

      {error && (
        <div className="bg-red-600 text-white px-4 py-2 rounded-2xl mb-6">
          {error}
        </div>
      )}
      {message && (
        <div className="bg-green-600 text-white px-4 py-2 rounded-2xl mb-6">
          {message}
        </div>
      )}

      <form
        onSubmit={handleChange}
        className="bg-gray-800 p-8 rounded-2xl shadow-md w-full max-w-md space-y-6"
      >
        <div>
          <label className="block mb-2 font-semibold">
            {t('changePassword.oldPassword')}
          </label>
          <input
            type="password"
            value={oldPassword}
            onChange={e => setOldPassword(e.target.value)}
            required
            className="w-full p-3 rounded bg-gray-700 text-white focus:outline-none"
            placeholder={t('changePassword.oldPasswordPlaceholder')}
            autoComplete="current-password"
          />
        </div>

        <div>
          <label className="block mb-2 font-semibold">
            {t('changePassword.newPassword')}
          </label>
          <input
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            required
            className="w-full p-3 rounded bg-gray-700 text-white focus:outline-none"
            placeholder={t('changePassword.newPasswordPlaceholder')}
            autoComplete="new-password"
          />
        </div>

        <button
          type="submit"
          className="w-full bg-mentixxgreen hover:bg-green-400 text-black font-bold py-3 rounded-2xl transition"
        >
          {t('changePassword.changeButton')}
        </button>
      </form>

      <button
        type="button"
        className="mt-8 text-gray-300 hover:underline"
        onClick={() => navigate(-1)}
      >
        {t('changePassword.cancel')}
      </button>
    </div>
  )
}

export default ChangePasswordPage
